export default __webpack_public_path__ + "static/media/qsys-pin.fce326a6.png";